import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/opis-prices",
    name: "OPIS Prices",
    component: () => import("./opisPrices.vue"),
  },
  {
    path: "/opis-vendor-pricing-listing",
    name: "OPIS Vendor Pricing",
    component: () => import("./opisVendorPricing.vue"),
  },
] satisfies RouteRecordRaw[];
